
export const webUrl = 'https://ilogically.com'; 
export const appTokenString ='testprism';

// JosefCrack@2424